import { BorrowerFileType } from '@nemuru-eng/js-api-client';

export const NIF_DOCUMENT_ID_FILE_TYPES = [BorrowerFileType.DOCUMENT_ID_FRONT, BorrowerFileType.DOCUMENT_ID_BACK];

export const PASSPORT_DOCUMENT_ID_FILE_TYPES = [BorrowerFileType.PASSPORT];

export const NIE_EU_DOCUMENT_ID_FILE_TYPES = [...NIF_DOCUMENT_ID_FILE_TYPES, ...PASSPORT_DOCUMENT_ID_FILE_TYPES];

export const NIF_VIDEO_ID_FILE_TYPES = [
  BorrowerFileType.DOCUMENT_ID_FACE,
  BorrowerFileType.BIOMETRICS_FACE,
  BorrowerFileType.KYC_VIDEO,
];

export const NIE_EU_VIDEO_ID_FILE_TYPES = [
  BorrowerFileType.PASSPORT,
  BorrowerFileType.BIOMETRICS_FACE,
  BorrowerFileType.KYC_VIDEO,
];

export const DOCUMENT_ID_FACE_FILE_TYPES = [BorrowerFileType.DOCUMENT_ID_FACE];

export const BIOMETRICS_FILE_TYPES = [BorrowerFileType.BIOMETRICS_FACE];

export const BANK_ACCOUNT_DOCUMENT_FILE_TYPES = [BorrowerFileType.BANK_ACCOUNT_OWNERSHIP_DOCUMENTATION];

export const INCOME_DOCUMENT_FILE_TYPES = [
  BorrowerFileType.BANK_READER_INCOME,
  BorrowerFileType.PAYROLL,
  BorrowerFileType.LAST_FULL_PAYROLL,
  BorrowerFileType.PAYROLL_TWO_PREVIOUS_MONTHS,
  BorrowerFileType.PAYROLL_THREE_MONTHS_EARLIER,
  BorrowerFileType.PENSION_REVALUATION_LETTER,
  BorrowerFileType.PENSION_DOCUMENT,
  BorrowerFileType.LAST_PENSION_INCOME,
  BorrowerFileType.SEPE_DOCUMENT,
  BorrowerFileType.UNEMPLOYMENT_INCOME_DOC,
  BorrowerFileType.CONTRIBUTION_BASE,
  BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_CURRENT_YEAR,
  BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_LAST_YEAR,
  BorrowerFileType.PERSONAL_INCOME_TAX,
  BorrowerFileType.TAX_VAT_LAST_QUARTER,
  BorrowerFileType.TAX_VAT_PREVIOUS_QUARTER,
  BorrowerFileType.MODELO_303_CURRENT_YEAR,
  BorrowerFileType.MODEL_200_LAST_YEAR,
  BorrowerFileType.MODEL_130_1T,
  BorrowerFileType.MODEL_130_2T,
  BorrowerFileType.MODEL_130_3T,
  BorrowerFileType.MODEL_130_4T,
  BorrowerFileType.MODELO_300_1T,
  BorrowerFileType.MODELO_300_2T,
  BorrowerFileType.MODELO_300_3T,
  BorrowerFileType.MODELO_300_4T,
  BorrowerFileType.MODEL_390_LAST_YEAR,
  BorrowerFileType.SELF_EMPLOYMENT_FEE_VERIFIER,
];

export const VALIDATION_EXCLUDED_FILE_TYPES = [
  BorrowerFileType.BANK_READER_INCOME,
  BorrowerFileType.BIOMETRICS_DOCUMENT,
  BorrowerFileType.DOCUMENT_ID_SIGNATURE,
] as BorrowerFileType[];
